// shallow query serializer that'll work server & client-side
const querySerializer = {
  stringify: query => Object.keys(query).map(p => `${p}=${query[p]}`).join('&'),
  parse: qs => {
    if (!qs) return undefined;

    const qsProps = qs.split('&');

    return qsProps.map(propVal => {
      const [prop, val] = propVal.split('=');

      return { [prop]: isNaN(val) ? val : Number(val) };
    }).reduce((query, item) => ({
      ...query,
      ...item,
    }), {});
  },
};

export default querySerializer;



// WEBPACK FOOTER //
// ./src/lib/query-serializer.js